export const AVAILABLE_LANGUAGES = [
  'en',
  'zh-HK',
  'zh-CN',
  'id',
  'pt-BR',
] as const;
